<template>

	<section class="full-width no-padding-top" id="account-preferences">

		<div class="container">

			<div class="row heading">

				<div class="col-12">
					<h2>My preferences</h2>
				</div>

			</div>

			<div class="row">

				<div class="col-12">

					<div class="question pref" v-show="!questionnaire || question === 1">

						<h3>Are you pregnant (or would you like postpartum support)?</h3>

						<div class="inline-fields" data-children-count="1">
							<input v-model="preferences.pregnant" type="radio" v-bind:value="true">
							<label>Yes</label>
						</div>
						<div class="inline-fields" data-children-count="1">
							<input v-model="preferences.pregnant" type="radio" v-bind:value="false">
							<label>No</label>
						</div>

						<div class="form-group" v-show="preferences && preferences.pregnant">
							<label for="due_date">Congratulations! When is your due date (or the date you gave birth)?</label>
							<input v-model="preferences.pregnant_due_date" type="date" min="2020-01-01" name="pregnant_due_date">
						</div>

						<div v-if="show_pregnancy_validation_message" class="validation-message">Please enter a valid due date</div>

					</div>

					<div class="question pref" v-show="!questionnaire || question === 2">

						<h3>What are your dietary preferences?</h3>

						<select class="core-prevent-select2" v-model="dietary_preference_selected">
							<option value="">Include meat options</option>
							<option v-for="preference in dietary_preferences" :key="preference.term_id" :value="preference.term_id" :selected="dietary_preference_selected==preference.term_id">{{preference.name}}</option>
						</select>

					</div>

					<div class="question pref" v-show="!questionnaire || question === 3">

						<h3>Which cooking measurements do you want to use?</h3>

						<select class="core-prevent-select2" v-model="units">
							<option value="metric">Metric (g, mL, kg)</option>
							<option value="imperial">Imperial (oz, lb)</option>
						</select>

					</div>

					<button class="core-btn" v-bind:disabled="thinking" v-if="questionnaire" @click="prevQuestion()">Previous</button>
					<button class="core-btn" v-bind:disabled="thinking" v-if="questionnaire" @click="nextQuestion()">Next</button>
					<button v-if="!questionnaire" @click.prevent="saveDetails" :disabled="thinking" class="core-btn">Save preferences</button>

				</div>

			</div>

		</div>

	</section>

</template>

<script>
	module.exports = {
		name: "account-preferences",

		data() {
			return {
				thinking: false,

				preferences: coreHelpers.getNested(pageData, "preferences")
					? pageData.preferences
					: { pregnant: false, pregnant_due_date: false },

				dietary_preferences: coreHelpers.getNested(
					pageData,
					"dietary_preferences"
				)
					? pageData.dietary_preferences
					: "",
				dietary_preference_selected: coreHelpers.getNested(
					pageData,
					"preferences",
					"dietary_preference_selected"
				)
					? pageData.preferences.dietary_preference_selected
					: "",
				units: coreHelpers.getNested(pageData, "preferences", "units")
					? pageData.preferences.units
					: "metric",

				user_id: pageData.user_profile.user_id
					? pageData.user_profile.user_id
					: null,

				numberOfQuestions: null,

				show_pregnancy_validation_message: false,
			};
		},

		watch: {
			preferences: {
				handler(val) {
					if (this.questionnaire) {
						if (val.pregnant === true) {
							window.questionnaire.pregnant = true;
						} else {
							window.questionnaire.pregnant = false;
						}
					}
				},
				deep: true,
			},
		},

		mounted() {
			this.numberOfQuestions =
				document.querySelectorAll(".question.pref").length;
		},

		props: {
			questionnaire: {
				default: false,
				type: Boolean,
			},

			question: {
				default: 1,
				type: Number,
			},
		},

		methods: {
			nextQuestion() {
				//pregnancy question validation
				if (this.question === 1) {
					const pregDueDate = coreHelpers.getNested(
						this,
						"preferences",
						"pregnant_due_date"
					);

					if (
						coreHelpers.getNested(this, "preferences", "pregnant") &&
						(!pregDueDate ||
							pregDueDate === "false" ||
							pregDueDate === "")
					) {
						this.show_pregnancy_validation_message = true;
						return false;
					} else {
						this.show_pregnancy_validation_message = false;
					}
				}

				window.questionnaire.next();

				//if this is the last question
				if (this.question === this.numberOfQuestions) {
					this.saveDetails();
				}
			},

			prevQuestion() {
				window.questionnaire.prev();
			},

			saveDetails() {
				this.thinking = true;

				if (
					coreHelpers.getNested(this, "preferences", "pregnant") &&
					(!coreHelpers.getNested(
						this,
						"preferences",
						"pregnant_due_date"
					) ||
						coreHelpers.getNested(
							this,
							"preferences",
							"pregnant_due_date"
						) === "")
				) {
					coreVariables.triggerModal(
						"Slight issue",
						"Please enter your due date"
					);
					this.thinking = false;
					return false;
				}

				window.coreHelpers.ajax.call(
					this,
					"POST",
					"lc_update_preferences",
					{
						prefs: {
							dietary_preference_selected:
								this.dietary_preference_selected,
							pregnant:
								this.preferences.pregnant === true ? true : false,
							pregnant_due_date: this.preferences
								? this.preferences.pregnant_due_date
								: false,
							units: this.units ? this.units : "metric",
						},
					},
					function (res) {
						this.thinking = false;

						if (!this.questionnaire) {
							document.cookie =
								"lc_preferences= ; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
							coreVariables.triggerModal(
								"Success",
								"Your preferences have been saved"
							);
						}
					},
					function (res) {
						this.thinking = false;

						if (!this.questionnaire) {
							coreVariables.triggerModal(
								"Slight issue",
								"We could not save your preferences, please try again later"
							);
						}
					}
				);
			},
		},
	};
</script>